/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MailInStatus {
    Processing = '0',
    Failed = 1,
    Success = 2,
}
